// Libraries
import { useRecoilState, useResetRecoilState } from "recoil";
// State
import { Species, speciesActiveState, speciesListState } from "state";

interface UseStateSpeciesReturn {
  active?: Species;
  count: number;
  list?: Species[];
  resetList: () => void;
  setActive: (newSpecies: Species) => void;
  setList: (newSpeciesList: Species[]) => void;
}

export const useStateSpecies = (): UseStateSpeciesReturn => {
  const [speciesActive, setSpeciesActive] = useRecoilState(speciesActiveState);
  const [speciesList, setSpeciesList] = useRecoilState(speciesListState);
  const resetSpeciesList = useResetRecoilState(speciesListState);
  const speciesCount = speciesList?.length || 0;

  const handleSetActive = (newSpecies): void => setSpeciesActive(newSpecies);

  const handleResetList = (): void => resetSpeciesList();
  const handleSetList = (newSpeciesList): void => setSpeciesList(newSpeciesList);

  return {
    active: speciesActive,
    count: speciesCount,
    list: speciesList,
    resetList: handleResetList,
    setActive: handleSetActive,
    setList: handleSetList,
  };
};
